import React from 'react';
import { popupOpenService } from '../../../shared/popupOpenService';
import { TrashIcon } from '../../../appearence/icons/trash_icon';
import { POPUP_KEY_DELETE_PRODUCT_PROPERTY } from '../../../constant';
import {IconWrapper} from "../../../appearence/icons/icon_wrapper";

const DeleteProductPropertyIcon = ({ propertyId }) => {
    const openDeleteProductPropertyPopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_DELETE_PRODUCT_PROPERTY, propertyId);
    };

    return (
        <span onClick={openDeleteProductPropertyPopup}>
            <IconWrapper><TrashIcon /></IconWrapper>
        </span>
    );
};

export default DeleteProductPropertyIcon;
